import { sumBy } from "lodash";
import promotions from "@/mixins/promotions";

let isCouponValueApplied = false;

export default {
  mixins: [
    promotions
  ],
  methods: {
    calculateTotalPrice(prices, options) {
      isCouponValueApplied = false;

      options = options || {};

      return sumBy(prices, price => {
        return this.calculateSinglePrice(price, options);
      });
    },
    calculateSinglePrice(price, options) {
      options = options || {};

      let result = parseFloat(price.amount);

      if (options.quantity) {
        result = result * options.quantity;
      }
      if (options.promotion) {
        result = this.calculateSinglePriceWithPromotion({
          ...price,
          amount: result
        }, options.promotion, options);
      }
      if (options.promotions) {
        result = this.calculateSinglePriceWithPromotions({
          ...price,
          amount: result
        }, options.promotions, options);
      }
      if (options.withRoomTypePromotions && options.roomType) {
        result = this.calculateSinglePriceWithRoomTypePromotions({
          ...price,
          amount: result
        }, options.roomType, options);
      }

      return result;
    },
    calculateSinglePriceWithPromotion(price, promotion, options) {
      let result = parseFloat(price.amount);

      if (this.isCouponValuePromotion(promotion)) {
        return this.calculateSinglePriceWithCoupon(price, promotion, options);
      }

      if (!price.date) {
        return this.applyPromotion(result, promotion);
      }

      const dayOfWeek = this.$moment(price.date).day();

      if (!promotion.weekdays || promotion.weekdays.indexOf(dayOfWeek) > -1) {
        result = this.applyPromotion(result, promotion);
      }

      return result;
    },
    calculateSinglePriceWithCoupon(price, coupon, options) {
      let result = parseFloat(price.amount);

      if (isCouponValueApplied || options.skipCoupon) {
        return result;
      }

      isCouponValueApplied = true;

      return this.applyPromotion(result, coupon);
    },
    calculateSinglePriceWithPromotions(price, promotions, options) {
      options = options || {};

      let result = parseFloat(price.amount);

      if (!promotions || !promotions.length) {
        return result;
      }

      promotions.forEach(promotion => {
        result = this.calculateSinglePriceWithPromotion({
          ...price,
          amount: result
        }, promotion, options);
      });

      return result;
    },
    calculateSinglePriceWithRoomTypePromotions(price, roomType, options) {
      options = options || {};

      const promotions = this.getRoomTypePromotions(roomType, options.property, options.withBestPropertyPromotion);
      return this.calculateSinglePriceWithPromotions(price, promotions, options);
    },
    calculateTotalPriceToPay(prices, options) {
      let total = this.calculateTotalPrice(prices, options);

      if (options.isRefundable && options.deposit > 0) {
        return (total/100) * options.deposit;
      }

      return total;
    }
  }
}
